import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../actions/layoutActions";
import * as sessionActions from "../actions/sessionActions";
import * as securityActions from "../actions/securityActions";
import * as loginActions from "../actions/loginActions";
import { throwException } from "../actions/exceptionActions";
import * as ajaxActions from "../actions/ajaxCounterActions";

import SecurityApi from "../api/shared/securityApi";

import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";
import { showToastrSuccess, showToastrError } from "../util/toastr.js";
import { Environments } from "../constants/DomainConstants";

import RelativeLink from "./common/RelativeLink";
import Section from "./common/Section";
import Fieldset from "./common/Fieldset";
import Row from "./common/Row";
import Col from "./common/Col";
import Button from "./common/Button";
import SelectInput from "./common/SelectInput";
import * as types from "../constants/ComponentConstants";
import redirector from "../util/redirector";
import mergeDeep from "../util/mergeDeep";

import appstore from "../images/appstore.jpg";
import facebook from "../images/facebook.png";
import googlePlay from "../images/googleplay.png";
import icoonEkendeClubsFeds from "../images/IcoonErkendeClubsFeds.png";
import idIcon from "../images/idIcon.jpg";
import sponsorLogoNatuurEnBos from "../images/SponsorlogoNatuurEnBos.png";
import twitter from "../images/twitter.png";

class TestPage extends Component {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            federatieOndernemingsnummer: null,
            federatieId: null,
            federatieEmail: null,
            federatieNaam: null,
            federatieGebruikersnaam: null,
            sportclubId: null,
            sportclubToReset: null,
            nieuweSportclubPoId: null,
            nieuweSportclubGebruikersnaam: null,
            gemeenteOndernemingsnummer: null,
            gemeenteId: null,
            gemeenteEmail: null,
            gemeenteNaam: null,
            gemeenteGebruikersnaam: null,
        };
    }

    componentDidMount() {
        if (this.props.environments === Environments.PRD) {
            redirector.goTo("/federatie/overzicht");
        }

        this.props.loadLayout();
        this.props.setActiveSportclub('00000000-0000-0000-0000-000000024156');
    }

    nukeCache() {
        const listByUrl = prependRoot("/global/nukecache", getApiRoot());
        axios.get(listByUrl, {
            headers: {
                'accept': 'application/json'
            }
        }).then(response => {
            if (response.statusText === "OK") {
                showToastrSuccess("Cache Cleared");
            } else {
                showToastrError("FAILED. OH NO... :(");
            }
        });
    }

    onChange = (event) => {
        const property = event.target.name;
        const value = event.target.value;

        let newState = Object.assign({}, this.state);
        newState[property] = value;

        this.setState(
            newState
        );
    };

    onClickGoToFederatieOverzicht = () => {
        redirector.goTo("/federatie/overzicht");
        // this.props.initSession([this.state.federatieOndernemingsnummer], this.state.federatieGebruikersnaam).then(function () {
        //     redirector.goTo("/federatie");
        // });
    };

    onClickGoToGemeenteOverzicht = () => {
        redirector.goTo("/gemeente/overzicht");
        // this.props.setActiveGemeente([this.state.gemeenteOndernemingsnummer], this.state.gemeenteGebruikersnaam).then(function () {
        //     redirector.goTo("/gemeente/overzicht");
        // });
    };

    // onClickGoToAdressen = () => {
    //     this.props.initSession(this.state.ondernemingsnummer, this.state.federatieGebruikersnaam);
    //     this.props.setActiveSportclub(this.state.sportclubId, null, false);
    //     redirector.goTo("/sportorganisatie/adres/" + this.state.sportclubId);
    // }

    // onClickGoToTabOrganisatie = () => {
    //     this.props.initSession([this.state.federatieOndernemingsnummer], this.state.federatieGebruikersnaam);
    //     redirector.goTo(`/sportorganisatie/organisatie/${this.state.sportclubId}/`);

    //     this.props.setActiveSportclub(this.state.sportclubId, null, false);
    // }

    // onClickSetHeaderDataFederatie = (federatieId, federatieOndernemingsnummer, federatieNaam, gebruikersnaam, email) => {
    //     this.props.initSession([federatieOndernemingsnummer], gebruikersnaam);
    //     this.setState({
    //         federatieId: federatieId,
    //         federatieOndernemingsnummer: federatieOndernemingsnummer,
    //         federatieEmail: email,
    //         federatieNaam: federatieNaam,
    //         federatieGebruikersnaam: gebruikersnaam
    //     });
    // }

    // onClickSetHeaderDataNieuweSportclub = (gebruikersnaam, poId) => {
    //     this.props.setActiveNieuweSportclub(gebruikersnaam, poId);
    //     this.setState({
    //         nieuweSportclubGebruikersnaam: gebruikersnaam,
    //         nieuweSportclubPoId: poId
    //     });
    // }

    // onClickSetHeaderDataGemeente = (gemeenteId, gemeenteOndernemingsnummer, gemeenteNaam, gebruikersnaam, email) => {
    //     this.props.setActiveGemeente([gemeenteOndernemingsnummer], gebruikersnaam);
    //     this.setState({
    //         gemeenteId: gemeenteId,
    //         gemeenteOndernemingsnummer: gemeenteOndernemingsnummer,
    //         gemeenteEmail: email,
    //         gemeenteNaam: gemeenteNaam,
    //         gemeenteGebruikersnaam: gebruikersnaam
    //     });
    // };

    // onClickSetSportClubId = (sportclubId) => {
    //     this.setState({
    //         sportclubId: sportclubId
    //     });
    //     this.props.setActiveSportclub(sportclubId, null, false);
    // }

    // onClickResetSportClubId = () => {
    //     const listByUrl = prependRoot(`/sportclub/resetsportclub/${this.state.sportclubToReset}`, getApiRoot());
    //     axios.get(listByUrl, {
    //         headers: {
    //             'accept': 'application/json'
    //         }
    //     }).then(response => {
    //         if (response.statusText === "OK") {
    //             showToastrSuccess("Sportclub Reset");
    //         } else {
    //             showToastrError("FAILED. OH NO... :(");
    //         }
    //     });
    // }

    // onClickExportClubsGemeente = () => {
    //     gemeenteApi.createExportRequestForSportclubs({ ondernemingsnummer: this.state.gemeenteOndernemingsnummer, email: this.state.gemeenteEmail });
    // }

    onChangeOrganisation = (e) => {
        const { state, props } = this;
        const organisatieId = props.organisaties.length === 1 ? props.organisaties[0].id : e.target.value;
        const organisatie = mergeDeep({}, props.organisaties.find(o => o.id === organisatieId));
        const ajaxActions = props.ajaxActions;

        this.setState({ selectedOrganisatieId: e.target.value });

        if (organisatie && organisatie.id) {
            ajaxActions.started();

            SecurityApi.switchOrganisatie(organisatie.ondernemingsnummer).then(() => {
                ajaxActions.ended();
                props.setCurrentOrganisation(organisatie);
            }).catch((ex) => {
                props.throwException(ex);
            });
        }
    };

    render() {
        const federatieId = this.state.federatieId;
        const federatieOndernemingsnummer = this.state.federatieOndernemingsnummer;
        const federatieGebruikersnaam = this.state.federatieGebruikersnaam;
        const sportclubId = this.state.sportclubId;
        const federatieEmail = this.state.federatieEmail;
        const federatieNaam = this.state.federatieNaam;
        const sportclubToReset = this.state.sportclubToReset;
        const nieuweSportclubGebruikersnaam = this.state.nieuweSportclubGebruikersnaam;
        const nieuweSportclubPoId = this.state.nieuweSportclubPoId;

        const gemeenteOndernemingsnummer = this.state.gemeenteOndernemingsnummer;
        const gemeenteId = this.state.gemeenteId;
        const gemeenteEmail = this.state.gemeenteEmail;
        const gemeenteNaam = this.state.gemeenteNaam;
        const gemeenteGebruikersnaam = this.state.gemeenteGebruikersnaam;

        const onChange = this.onChange;
        const divStyle = { background: "#f6f6f6", borderRadius: "5px", margin: "10px" };
        const headerStyle = { 'color': '#006fB7', 'fontSize': '32px', 'textAlign': 'center', 'fontWeight': '500', 'padding': '0px', 'margin': '0px', 'backgroundColor': 'white', 'minHeight': '91.2px', 'paddingTop': '7px' };
        const selectStyle = { 'color': '#006fB7', 'fontSize': '32px', 'textAlignLast': 'center', 'fontWeight': '500', 'padding': '0px', 'margin': 'auto', 'backgroundColor': 'white', 'minHeight': '91.2px', 'width': 'auto' };

        return (
            <Section title={"Sport Databank Beheer (portal) - test page"} color={types.COLOR_BLUE}>
                {
                    <div style={{ 'backgroundColor': 'white', 'textAlign': 'center' }}>
                        <SelectInput defaultItem="Kies je sportorganisatie ......" style={selectStyle} name="selectedOrganisatieId" value={this.state.selectedOrganisatieId} items={this.props.organisatiesForList} onChange={this.onChangeOrganisation} />
                    </div>
                }
                <Fieldset title="">
                    <Row>
                        <Col>
                            <div style={divStyle}>
                                <Fieldset title="Overzicht sportclubs van sportfederatie">
                                    <Button
                                        onClick={this.onClickGoToFederatieOverzicht}
                                        title="Go to Overzicht"
                                        className="c-button c-button--small"
                                        disabled={!this.state.selectedOrganisatieId}
                                        text="Overzicht Federatie" />
                                    <br />
                                    <br />
                                </Fieldset>
                            </div>
                        </Col>
                        <Col>
                            <div style={divStyle}>
                                <Fieldset title="Overzicht sportclubs van Gemeente">
                                    <Button
                                        onClick={this.onClickGoToGemeenteOverzicht}
                                        title="Go to Overzicht"
                                        className="c-button c-button--small"
                                        disabled={!this.state.selectedOrganisatieId}
                                        text="Overzicht Gemeente" />
                                    <br />
                                    <br />
                                </Fieldset>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div style={divStyle}>
                                <Fieldset>
                                    <br />
                                    <RelativeLink to={"/nieuwesportclub/"} title="Meld nieuwe sportorganisatie" className="c-button c-button--small">
                                        Meld nieuwe sportorganisatie
                                    </RelativeLink>
                                    <br />
                                    <br />
                                    <RelativeLink to={"/wijzigsportclub/"} title="Wijzig sportorganisatie" className="c-button c-button--small">
                                        Wijzig sportorganisatie
                                    </RelativeLink>
                                    <br />
                                    <br />
                                </Fieldset>
                            </div>
                        </Col>
                        <Col>
                            <div style={divStyle}>
                                <Fieldset>
                                    <br />
                                    <RelativeLink to={"/demo"} title="Demo" className="c-button c-button--small">
                                        Demo
                                </RelativeLink>
                                    <br />
                                    <br />
                                    <Button
                                        className="c-button c-button--small"
                                        text={"Clear Cache"}
                                        onClick={this.nukeCache} />
                                    <br />
                                    <br />
                                </Fieldset>
                            </div>
                        </Col>
                    </Row>
                </Fieldset>
                <br />
                <br />
                <br />
                <Row>
                    Images:
                    <img style={{ "height": "3rem" }} src={appstore} />
                    <img style={{ "height": "3rem" }} src={facebook} />
                    <img style={{ "height": "3rem" }} src={googlePlay} />
                    <img style={{ "height": "3rem" }} src={icoonEkendeClubsFeds} />
                    <img style={{ "height": "3rem" }} src={idIcon} />
                    <img style={{ "height": "3rem" }} src={sponsorLogoNatuurEnBos} />
                    <img style={{ "height": "3rem" }} src={twitter} />
                </Row>
            </Section >);
    }
}

TestPage.propTypes = {
    loadLayout: PropTypes.func,
    setActiveSportclub: PropTypes.func,
    environments: PropTypes.string,
    setActiveNieuweSportclub: PropTypes.func,
    organisaties: PropTypes.array,
    organisatiesForList: PropTypes.array,
    setCurrentOrganisation: PropTypes.func,
	ajaxActions: PropTypes.func,
	throwException: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        organisatiesForList: state.security.organisations ? [...state.security.organisations.map(f => mergeDeep({}, { label: f.naam, value: f.id }))] : [],
        organisaties: state.security.organisations || [],
        environment: state.settings.environment
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        loadLayout: bindActionCreators(layoutActions.loadTestPageLayout, dispatch),
        setActiveSportclub: bindActionCreators(sessionActions.setActiveSportclubId, dispatch),
        setActiveNieuweSportclub: bindActionCreators(loginActions.initialiseLoginSession, dispatch),
        setCurrentOrganisation: bindActionCreators(securityActions.setCurrentOrganisation, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TestPage);
